import throttle from 'lodash/throttle';

export const preventDoubleClick = (fn: () => void): (() => void) =>
  // Время анимации слайдера
  throttle(fn, 1000, { leading: true, trailing: false });
